
import {
  validName
} from '@/services/index'
import i18n from '@/lib/language'
const testPwd = (value) => {
  // const result1 = /^[\w\W]{8,30}$/.test(value)
  // const result2 = /[0-9]/.test(value)
  // const result3 = /[a-zA-Z]/.test(value)
  // if (result1 && result2 && result3) {
  //   return true
  // }
  // return false
  if (value.length >= 8) {
    return true
  }
  return false
}
const rules = {
  account: [
    { required: true, message: i18n.t('message["765"]'), trigger: 'blur' }
  ],
  user: [
    { required: true, message: i18n.t('message["763"]'), trigger: 'blur' }
  ],
  password: [
    { required: true, message: i18n.t('message["784"]'), trigger: 'blur' },
    {
      validator (rule, value, callback) {
        if (value) {
          if (!testPwd(value)) {
            callback(new Error(i18n.t('message["753"]')))
          } else {
            callback()
          }
        }
        callback()
      }
    }
  ],
  password2: [
    { required: true, message: i18n.t('message["762"]'), trigger: 'blur' },
    {
      validator (rule, value, callback) {
        if (value) {
          if (!testPwd(value)) {
            callback(new Error(i18n.t('message["753"]')))
          } else {
            callback()
          }
        }
        callback()
      }
    }
  ],
  newPwd: [
    { required: true, message: i18n.t('message["816"]'), trigger: 'blur' },
    {
      validator (rule, value, callback) {
        if (value) {
          if (!testPwd(value)) {
            callback(new Error(i18n.t('message["753"]')))
          } else {
            callback()
          }
        }
        callback()
      }
    }
  ],
  repeatPwd: [
    { required: true, message: i18n.t('message["890"]'), trigger: 'blur' },
    {
      validator (rule, value, callback) {
        if (!testPwd(value)) {
          callback(new Error(i18n.t('message["753"]')))
        } else {
          callback()
        }
      },
      trigger: 'blur'
    }
  ],
  email: [
    { required: true, type: 'email', message: i18n.t('message["834"]'), trigger: 'blur' }
  ],
  validCode: [
    { required: true, message: i18n.t('message["824"]'), trigger: 'blur' }
  ],
  username: [
    { required: true, message: i18n.t('message["763"]'), trigger: 'blur' },
    {
      async validator (rule, value, callback) {
        if (value) {
          await validName()
            .params({ username: value })
            .onSuccess((raw) => {
            })
            .onNetSuccess((raw) => {
              const res = raw.data
              if (res.error) {
                callback(new Error(res.message || res.payload[0].message))
              } else {
                callback()
              }
            })
            .config({ tip: false })
            .fetch()
        }
      },
      trigger: 'blur'
    }
  ],
  truename: [
    { required: true, message: i18n.t('message["788"]'), trigger: 'blur' },
    {
      async validator (rule, value, callback) {
        if (value) {
          await validName()
            .params({ truename: value })
            .onSuccess((raw) => {
            })
            .onNetSuccess((raw) => {
              const res = raw.data
              if (res.error) {
                callback(new Error(res.message || res.payload[0].message))
              } else {
                callback()
              }
            })
            .config({ tip: false })
            .fetch()
        }
      },
      trigger: 'blur'
    }
  ],
  name: [
    { required: true, message: i18n.t('message["772"]'), trigger: 'blur' }
  ],
  tel: [
    { required: true, message: i18n.t('message["800"]'), trigger: 'blur' },
    {
      validator (rule, value, callback) {
        var errors = []
        if (value && (!/^1\d{10}$/.test(value))) {
          errors.push(
            new Error(
              i18n.t('message["1111"]')
            ))
        }
        return errors
        // if (value && (!/^1\d{10}$/.test(value))){
        //   callback('Two passwords that you enter is inconsistent!');
        // } else {
        //   callback();
        // }
      },
      trigger: 'change'
    }
  ],
  title: [
    { required: true, message: i18n.t('message["771"]'), trigger: 'blur' }
  ],
  title2: [
    { required: true, message: i18n.t('message["759"]'), trigger: 'blur' }
  ],
  identifynumber: [
    { required: true, message: i18n.t('message["786"]'), trigger: 'blur' }
  ],
  contenttype: [
    { required: true, message: i18n.t('message["67"]'), trigger: 'blur' }
  ],
  regaddress: [
    { required: true, message: i18n.t('message["839"]'), trigger: 'blur' }
  ],
  regtel: [
    { required: true, message: i18n.t('message["840"]'), trigger: 'blur' }
  ],
  bankdeposit: [
    { required: true, message: i18n.t('message["781"]'), trigger: 'blur' }
  ],
  bankaccount: [
    { required: true, message: i18n.t('message["825"]'), trigger: 'blur' }
  ],
  consignee: [
    { required: true, message: i18n.t('message["798"]'), trigger: 'blur' }
  ],
  contact: [
    { required: true, message: i18n.t('message["797"]'), trigger: 'blur' }
  ],
  address: [
    { required: true, message: i18n.t('message["796"]'), trigger: 'blur' }
  ],
  pca: [
    { required: true, message: i18n.t('message["795"]'), trigger: 'blur' }
  ]

}
export default rules
